import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonLight, ButtonStandard, formatMessage } from 'cw-ui-core';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';
import cx from 'classnames';
import css from './ForgetMFAUserDialog.scss';

export const FORGET_MFA_USER_DIALOG = 'FORGET_MFA_USER_DIALOG';

const ForgetMFAUserDialog = props => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={props.onCancel}
        />,
        <ButtonStandard
            key="forgetMfa"
            automationName="forgetMfa"
            className={css.forgetButton}
            value={formatMessage(Locale.forget)}
            onClick={props.onForget}
        />,
    ];

    return (
        <Dialog dialogId={FORGET_MFA_USER_DIALOG} header={formatMessage(Locale.forgetMFA)} buttons={dialogButtons}>
            <div className={cx(css.wrap, layoutCss.podCol)}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={FORGET_MFA_USER_DIALOG} />
                <Label value={formatMessage(Locale.forgetMFAConfirmation)} />
            </div>
        </Dialog>
    );
};

export default injectIntl(ForgetMFAUserDialog);
